export const SYSTEM_TYPES = {
  BOOT_SYSTEM: 'SYSTEM/BOOT_SYSTEM',
  REGISTER_PROCESS_PID: 'SYSTEM/REGISTER_PROCESS_PID',
  REGISTER_CONFIGURATION_PID: 'SYSTEM/REGISTER_CONFIGURATION_PID',
  UPDATE_PROCESS_PID: 'SYSTEM/UPDATE_PROCESS_PID',
  UPDATE_CACHE_PROCESS_PID: 'SYSTEM/UPDATE_CACHE_PROCESS_PID',
  CLEAR_CACHE_PROCESS_PID: 'SYSTEM/CLEAR_CACHE_PROCESS_PID',
  KILL_PROCESS_PID: 'SYSTEM/KILL_PROCESS_PID',
  KILL_ALL_PROCESS: 'SYSTEM/KILL_ALL_PROCESS'
}